import { useEffect } from "react";

const SITE_URL = "https://parusanakryshe.ru";

export interface BreadcrumbItem {
  name: string;
  path?: string;
}

export function useBreadcrumbs(items: BreadcrumbItem[]) {
  useEffect(() => {
    const all = [{ name: "Главная", path: "/" }, ...items];

    const schema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": all.map((item, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "name": item.name,
        ...(item.path ? { "item": `${SITE_URL}${item.path}` } : {}),
      })),
    };

    const id = "breadcrumb-schema";
    let el = document.getElementById(id) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement("script");
      el.id = id;
      el.type = "application/ld+json";
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(schema);

    return () => {
      const existing = document.getElementById(id);
      if (existing) existing.remove();
    };
  }, [JSON.stringify(items)]);
}
